// ユーザーキャンセルは failure 扱いせず silent return に使う（repository の connect が catch して null を返す）。
// producer: StandOperationRepository.connect(standId, { signal }) が AbortSignal の abort を
// これへ正規化する（aikasa/ikasa_platform#7595）。
export class BluetoothCancelException extends Error {
  constructor(message?: string) {
    super(message ?? 'bluetooth operation cancelled by user')
    this.name = 'BluetoothCancelException'
    Object.setPrototypeOf(this, BluetoothCancelException.prototype)
  }
}
